import { Close } from '@mui/icons-material';
import { Box, Button, IconButton, Modal, Typography } from '@mui/material';
import React from 'react';
import { useBookingsContext } from '../../../../contexts/BookingsContext';
import { BOOKING_STATUS } from '../../../../global/constants/status';
import { DeleteBookingModalStyles } from './styles';
interface DeleteBookingModalProps {
  open: boolean;
  onClose: () => void;
}

const DeleteBookingModal = ({ open, onClose }: DeleteBookingModalProps) => {
  const styles = DeleteBookingModalStyles();
  const {
    selectedBooking,
    setBookingModalUrl,
    setIsBookingModalOpen,
    updateBookingStatus: updateBookingStatus,
  } = useBookingsContext();

  const handleReschedule = () => {
    onClose();
    console.log(
      `load: ${window._env_?.BOOKING_APP_URL || process.env.REACT_APP_BOOKING_APP_URL}/reschedule/${selectedBooking?.confirmation_code}/${selectedBooking?.confirmation_code}?headless=1&dashboard=1`,
    );

    setBookingModalUrl(
      `${window._env_?.BOOKING_APP_URL || process.env.REACT_APP_BOOKING_APP_URL}/reschedule/${selectedBooking?.confirmation_code}/${selectedBooking?.confirmation_code}?headless=1&dashboard=1`,
    );
    setIsBookingModalOpen(true);
  };

  const handleDelete = async () => {
    try {
      await updateBookingStatus?.(BOOKING_STATUS.SESSION_CANCELED);
    } catch (error) {
      console.log('ERROR', error);
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={styles.modal}>
        <Box sx={styles.filterHeader}>
          <Typography marginLeft={'2rem'} fontSize={'0.9rem'} display={'flex'}>
            Are you sure you want to delete this booking?
            <IconButton sx={{ marginLeft: 'auto' }} onClick={onClose}>
              <Close />
            </IconButton>
          </Typography>

          <Typography marginLeft={'2rem'} fontSize={'0.75rem'} display={'flex'}>
            Once deleted, this booking can not be recovered
          </Typography>
          <Box
            marginTop={'1rem'}
            justifyContent={'space-evenly'}
            width={'100%'}
            display={'flex'}
            padding={'1rem'}>
            <Button
              sx={{
                color: '#0b1339',
                background: '#fff',
                textTransform: 'none',
              }}
              onClick={() => handleDelete}>
              Continue to delete
            </Button>
            <Button sx={styles.searchButton} onClick={() => handleReschedule}>
              Reschedule Booking
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default DeleteBookingModal;
